/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssetBalanceInfo } from './assetBalanceInfo';

/**
 * Balance info
 */
export interface BalanceInfo {
  ledgerId: string;
  balances: Array<AssetBalanceInfo>;
  businessEntity: BalanceInfo.BusinessEntityEnum;
}
export namespace BalanceInfo {
  export const BusinessEntityEnum = {
    Sandbox1: 'SANDBOX1',
    Sandbox2: 'SANDBOX2',
    Inc: 'INC',
    Bermuda: 'BERMUDA',
    Brazil: 'BRAZIL',
  } as const;
  export type BusinessEntityEnum = (typeof BusinessEntityEnum)[keyof typeof BusinessEntityEnum];
}
